import * as React from "react"
import trans from "trans"

import { Button, FieldLabel, Theme, Grid, TextInput, Icon} from "@bdfx/mergado-ui-kit"

import {
    DELETE_IMAGE_FROM_CUSTOM_SET,
    POST_CUSTOM_IMAGE_SET_FILE,
} from "template-edit/reducers"

import {
    CustomImageSetFile,
} from "app/types/model-types";

import {
    deleteCustomImageSetFile,
    projectId, getAllCustomImageSetFiles, saveCustomImageFile as apiSaveCustomImageFile,
    isGodModeOn,
    godProjectId,
} from "app/helpers/api";

import store from "store";
import {createToast} from "actions";
import toastFactory from "app/helpers/toast_factory";
import {URL} from "app/config/api-config";
import ShapeType, { CUSTOM_SET_TYPE } from "shape-entities/types/shape";
import {CustomSetItem} from "shape-edit/forms/custom-set-form";
import CustomSetToolbar from "shape-edit/forms/custom-set-toolbar";
import CustomSetSourceInfo, {getSourceInfoTitle} from "shape-edit/forms/custom-set-source-info";
import {AxiosResponse} from "axios";
import uniqueId from "app/helpers/unique_id";

const {round, max, min} = Math

interface Props {
}

interface State {
    allCustomSetFiles: CustomImageSetFile[]
    isLoading: boolean
}

class CustomSets extends React.Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            allCustomSetFiles: null,
            isLoading: false,
        }
    }

    componentDidMount() {
        this.getAllCustomSetFiles()
    }

    getAllCustomSetFiles = () => {
        this.setState({isLoading: true})
        getAllCustomImageSetFiles()
            .then((response: AxiosResponse<CustomImageSetFile[]>) => {
                this.setState({allCustomSetFiles: response.data.reverse()})
            })
            .catch(error => {
                console.debug('error while loading custom image sets', error)
            })
            .finally(() => this.setState({isLoading: false}))
    }

    handleRemoveImageFromSet = (removingSetFile: CustomImageSetFile) => {
        deleteCustomImageSetFile(removingSetFile)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(toastFactory(DELETE_IMAGE_FROM_CUSTOM_SET.SUCCESS, response.data)))
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(DELETE_IMAGE_FROM_CUSTOM_SET.ERROR, error)))
            })
            .finally(() => {
                this.getAllCustomSetFiles()
            })
    }

    getImageUrl = (setFile: CustomImageSetFile) => {
        const actualProjectId = isGodModeOn ? godProjectId : projectId
        return `${URL.laravelBase}customsets/${actualProjectId}/${setFile.set_id}/${setFile.filename}`;
    }

    downloadImage = (selectedFile: CustomImageSetFile) => {
            const previewUrl = this.getImageUrl(selectedFile)
            const link = document.createElement('a')
            link.href = previewUrl
            link.download = selectedFile.filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }

    render() {
        const { allCustomSetFiles, isLoading } = this.state

        return (
            <div className={isLoading ? 'muk-helper-loading-line' : ''} style={{ padding: '20px' }}>
                <CustomSetToolbar
                    allCustomSetFiles={allCustomSetFiles}
                    onFileReady={(file, img) => {
                        const newShape: ShapeType = {
                            is_draggable: false,
                            priority: 0,
                            type: CUSTOM_SET_TYPE,
                            x: 0,   //not used anywhere since there is not template yet
                            y: 0,
                            index: uniqueId(),
                            width: img.width,
                            height: img.height,
                            scale: 1,
                            imageBlob: file.base64,
                            name: file.name,
                            custom_set_id: null
                        }

                        apiSaveCustomImageFile(newShape, file.name)
                            .then((response: AxiosResponse<ShapeType>) => {
                                store.dispatch(createToast(toastFactory(POST_CUSTOM_IMAGE_SET_FILE.SUCCESS)))
                            })
                            .catch(error => {
                                console.error('cannot upload new file', error)
                                store.dispatch(createToast(toastFactory(POST_CUSTOM_IMAGE_SET_FILE.ERROR, error)))
                            })
                            .finally(() => {
                                this.getAllCustomSetFiles()
                            })
                    }}
                />

                <Grid cols="repeat(auto-fit, minmax(200px, 1fr))" gap={"15px"} className={'images-from-set'} style={{ marginTop: '20px' }}>
                    {allCustomSetFiles && allCustomSetFiles.map((setFile: CustomImageSetFile) => {
                        const previewUrl = this.getImageUrl(setFile)
                        return (
                            <CustomSetItem key={setFile.id}>
                                {setFile.is_used === null &&
                                    <span className='remove' title={trans('custom_image_set_remove_image')} onClick={() => this.handleRemoveImageFromSet(setFile)}>
                                        <Icon type={'trash-o'} size={20} color={Theme.red} />
                                    </span>
                                }

                                <span className='download' title={trans('download_image')} onClick={() => this.downloadImage(setFile)}>
                                    <Icon type={'download-radix'} size={20} color={Theme.blue} />
                                </span>


                                <img src={previewUrl} title={getSourceInfoTitle(setFile)} />

                                <div className="small">{setFile.width}x{setFile.height}</div>

                                <CustomSetSourceInfo
                                    setFile={setFile}
                                    onUpdated={(updatedSetFile) => this.setState({
                                        allCustomSetFiles: allCustomSetFiles.map(file => file.id === updatedSetFile.id ? updatedSetFile : file),
                                    })}
                                />
                            </CustomSetItem>
                        )
                    })}
                </Grid>
            </div>
        )
    }
}

export default CustomSets
